<template>
    <div class="bg-white rounded shadow min-h-screen">
        <Modal
            :text="modalText"
            id="modal_show1"
        />

        <TodaySaleStat :period="period" :currency-short-name="currentCurrencyShortName"/>

        <Row type="none" class="bg-white rounded shadow mt-3">
            <div class="container grid grid-cols-12 gap-3 py-4">
                <div class="col-span-12 lg:col-span-4 relative">
                    <img src="/images/search-interface-symbol.png" alt="" class="h-6 absolute left-2 top-2">
                    <b-form-input
                        class="border-gray-300 pl-10 w-full h-11"
                        :placeholder="$t('statistics.employee.employee')"
                        v-model="search.givenName"
                        @input="findByName"
                    />
                </div>
                <div class="col-span-12 sm:col-span-3 lg:col-start-5 lg:col-span-2">
                    <b-form-select
                        v-model="currentCurrencyShortName"
                        class="h-11 border-gray-300 focus:ring-0"
                    >
                        <b-form-select-option value="UZS">UZS</b-form-select-option>
                        <b-form-select-option value="USD">USD</b-form-select-option>
                        <b-form-select-option value="RUB">RUB</b-form-select-option>
                    </b-form-select>
                </div>
                <div class="col-span-12 sm:col-span-3 lg:col-span-2">
                    <b-form-select
                        v-model="statPeriod"
                        @change="defineStatPeriod"
                        class="h-11 border-gray-300 focus:ring-0"
                    >
                        <b-form-select-option :value="0">{{ $t('statistics.type.statByDay') }}</b-form-select-option>
                        <b-form-select-option :value="1">{{ $t('statistics.type.statByMonth') }}</b-form-select-option>
                        <b-form-select-option :value="2">{{ $t('statistics.type.statByYear') }}</b-form-select-option>
                    </b-form-select>
                </div>
                <div class="col-span-12 sm:col-span-6 lg:col-span-4">
                    <div v-if="isYearly">
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="selectedYear"
                            :options="optionsYear"
                            @change="yearlyStat">
                        </b-form-select>
                    </div>

                    <div v-if="isMonthly" class="flex gap-3">
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="selectedYear"
                            @change="monthlyStat"
                            :options="optionsYear">
                        </b-form-select>
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="selectedMonth"
                            :options="optionsMonth"
                            @change="monthlyStat">
                        </b-form-select>
                    </div>

                    <div v-if="isDaily">
                        <b-form-datepicker
                            :locale="$i18n.locale === 'uz' ? 'ru' : $i18n.locale"
                            style="height: 44px !important;"
                            class="border-gray-300 focus:ring-0"
                            id="example-datepicker"
                            v-model="currentDate"
                            :hide-header="hideHeader"
                            @input="dailyStat"
                        ></b-form-datepicker>
                    </div>
                </div>

                <div class="col-start-7 col-span-6">
                    <b-form-select @change="sortBy" v-model="sortByProduct" class="border-gray-300 h-11 focus:ring-0">
                        <b-form-select-option value="byTotalSum">{{ $t('statistics.employee.sum') }}</b-form-select-option>
                        <b-form-select-option value="byAverage">{{ $t('statistics.employee.avgReceipt') }}</b-form-select-option>
                        <b-form-select-option value="byReceiptAmount">{{ $t('statistics.employee.receiptCount') }}</b-form-select-option>
                        <b-form-select-option value="byIncome">{{ $t('statistics.employee.income') }}</b-form-select-option>
                    </b-form-select>
                </div>

                <div class="col-span-6">

                </div>
            </div>

            <table class="w-full">
                <thead class="h-11 bg-lightGray">
                <tr>
                    <td class="px-2 font-bold">#</td>
                    <td class="px-2 font-bold">{{ $t('statistics.employee.employee') }}</td>
                    <td class="px-2 font-bold">{{ $t('statistics.employee.sum') }}</td>
                    <td class="px-2 font-bold">{{ $t('statistics.employee.avgReceipt') }}</td>
                    <td class="text-center px-2 font-bold">{{ $t('statistics.employee.receiptCount') }}</td>
                    <td class="px-2 font-bold">{{ $t('statistics.employee.income') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="saleEmployee of saleEmployees" :key="saleEmployee.id" class="h-11">
                    <td>{{ saleEmployee.id }}</td>
                    <td class="font-bold text-main">{{ saleEmployee.person.givenName }} {{ saleEmployee.person.familyName }}</td>
                    <td>{{ showCurrencyById(baseCurrencyId, saleEmployee.totalSum) }}</td>
                    <td>{{ showCurrencyById(baseCurrencyId, saleEmployee.average) }}</td>
                    <td class="text-center">
                        {{ saleEmployee.amount }}
                    </td>
                    <td>{{ showCurrencyById(baseCurrencyId, saleEmployee.income) }}</td>
                </tr>
                </tbody>
            </table>

        </Row>

        <div class="row mt-4">
            <div class="col">
                <Pagination
                    :search="search"
                    base-url="statistics/product"
                    :total-items="isDaily ? getSaleEmployeeDailyTotalCount : isMonthly ? getSaleEmployeeMonthlyTotalCount : getSaleEmployeeYearlyTotalCount"
                    :method-name="isDaily ? 'fetchSaleEmployeeDaily' : isMonthly ? 'fetchSaleEmployeeMonthly' : 'fetchSaleEmployeeYearly'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import TodaySaleStat from "@/components/TodaySaleStat.vue";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import Modal from "@/components/html/Modal.vue";
import Pagination from "@/components/html/Pagination.vue";
import {mapActions, mapGetters} from "vuex";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import Row from "@/components/html/Row.vue";

export default {
    name: "EmployeeStat",
    components: {Row, Pagination, Modal, TodaySaleStat},
    mixins: [currencyFormatMixin, dateFormattingMixin],
    data() {
        return {
            search: {
                after: null,
                before: null,
                byTotalSum: true,
                byAverage: false,
                byReceiptAmount: false,
                byIncome: false,
                givenName: null,
                page: 1,
                isNeedFetch: false
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'statistics.employeeStat'},
            ],
            statPeriod: 0,
            sortByProduct: 'byTotalSum',
            isDaily: true,
            isMonthly: false,
            isYearly: false,
            hideHeader: false,
            selectedYear: null,
            selectedMonth: null,
            modalText: '',
            optionsMonth: [
                {value: {start: '01-01', end: '01-31'}, text: this.$t('statistics.month.Jan')},
                {value: {start: '02-01', end: '02-28'}, text: this.$t('statistics.month.Feb')},
                {value: {start: '03-01', end: '03-31'}, text: this.$t('statistics.month.Mar')},
                {value: {start: '04-01', end: '04-30'}, text: this.$t('statistics.month.Apr')},
                {value: {start: '05-01', end: '05-31'}, text: this.$t('statistics.month.May')},
                {value: {start: '06-01', end: '06-30'}, text: this.$t('statistics.month.Jun')},
                {value: {start: '07-01', end: '07-31'}, text: this.$t('statistics.month.Jul')},
                {value: {start: '08-01', end: '08-31'}, text: this.$t('statistics.month.Aug')},
                {value: {start: '09-01', end: '09-30'}, text: this.$t('statistics.month.Sep')},
                {value: {start: '10-01', end: '10-31'}, text: this.$t('statistics.month.Oct')},
                {value: {start: '11-01', end: '11-30'}, text: this.$t('statistics.month.Nov')},
                {value: {start: '12-01', end: '12-31'}, text: this.$t('statistics.month.Dec')},
            ],
            optionsYear: [],
            currentDate: null,
            currentMonth: null,
            saleEmployees: [],
            period: '',
            limit: 'all',
        }
    },
    computed: {
        ...mapGetters([
            'getSaleEmployeeDaily',
            'getSaleEmployeeMonthly',
            'getSaleEmployeeYearly',
            'getSaleEmployeeMonthlyTotalCount',
            'getSaleEmployeeYearlyTotalCount',
            'getSaleEmployeeDailyTotalCount',
            'getUserCompanyCreatedAt'
        ])
    },
    methods: {
        ...mapActions(['fetchSaleEmployeeDaily', 'fetchSaleEmployeeMonthly', 'fetchSaleEmployeeYearly', 'fetchUser', 'setBreadcrumbItems']),
        defineStatPeriod() {
            if (this.statPeriod === 0) {
                this.statByDays()
            } else if (this.statPeriod === 1) {
                this.statByMonth()
            } else {
                this.statByYear()
            }
        },
        statByDays() {
            this.$root.showOverlay = true

            this.isDaily = true
            this.isMonthly = false
            this.isYearly = false
            this.search.after = this.getTodayDate()
            this.search.before = this.getTodayDate()
            this.currentDate = this.getTodayDate()

            this.periodDefiner(new Date())
            this.fetchSaleEmployeeDaily(this.search)
                .then(() => {
                    this.$root.showOverlay = false
                    this.saleEmployees = this.getSaleEmployeeDaily
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        statByMonth() {
            this.$root.showOverlay = true

            this.isDaily = false
            this.isMonthly = true
            this.isYearly = false
            this.search.before = this.selectedYear + '-' + this.selectedMonth.end
            this.search.after = this.selectedYear + '-' + this.selectedMonth.start

            let date = {
                dateFrom: this.selectedYear + '-' + this.selectedMonth.start + 'T00:00:00',
                dateTo: this.selectedYear + '-' + this.selectedMonth.end + 'T23:59:59',
                isMonthly: true
            }

            this.periodDefiner(date.dateFrom, date.dateTo)
            this
                .fetchSaleEmployeeMonthly(this.search)
                .then(() => {
                    this.saleEmployees = this.getSaleEmployeeMonthly
                    this.$root.showOverlay = false
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        statByYear() {
            this.$root.showOverlay = true

            this.isDaily = false
            this.isMonthly = false
            this.isYearly = true
            this.search.after = this.selectedYear + '-' + 1 + '-' + 1
            this.search.before = this.selectedYear + '-' + 12 + '-' + 31

            this.periodDefiner(this.selectedYear, null, true)
            this
                .fetchSaleEmployeeYearly(this.search)
                .then(() => {
                    this.saleEmployees = this.getSaleEmployeeMonthly
                    this.$root.showOverlay = false
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        dailyStat() {
            this.$root.showOverlay = true

            this.search.after = this.currentDate + 'T00:00:00'
            this.search.before = this.currentDate + 'T23:59:59'

            this.periodDefiner(this.search.after)
            this.fetchSaleEmployeeDaily(this.search)
                .then(() => {
                    this.$root.showOverlay = false
                    this.saleEmployees = this.getSaleEmployeeDaily
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        monthlyStat() {
            this.$root.showOverlay = true

            if (this.selectedYear === null && this.selectedMonth === null) {
                return
            }

            this.search.after = this.selectedYear + '-' + this.selectedMonth.start + 'T00:00:00'
            this.search.before = this.selectedYear + '-' + this.selectedMonth.end + 'T23:59:59'

            let date = {
                dateFrom: this.selectedYear + '-' + this.selectedMonth.start + 'T00:00:00',
                dateTo: this.selectedYear + '-' + this.selectedMonth.end + 'T23:59:59',
                isMonthly: true
            }

            this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true
            this.$store.state.saleProductMonthlyRating.saleProductMonthlyRating.isNeedFetch = true

            this.periodDefiner(date.dateFrom, date.dateTo)
            this
                .fetchSaleEmployeeMonthly(this.search)
                .then(() => {
                    this.saleEmployees = this.getSaleEmployeeMonthly
                    this.$root.showOverlay = false
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        yearlyStat() {
            this.$root.showOverlay = true

            this.search.after = this.selectedYear + '-01-01T00:00:00'
            this.search.before = this.selectedYear + '-12-31T23:59:59'

            this.periodDefiner(this.selectedYear, null, true)
            this
                .fetchSaleEmployeeYearly(this.search)
                .then(() => {
                    this.saleEmployees = this.getSaleEmployeeMonthly
                    this.$root.showOverlay = false
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        sortBy() {
            switch (this.sortByProduct) {
                case "byTotalSum":
                    this.search.byTotalSum = true
                    this.search.byAverage = false
                    this.search.byReceiptAmount = false
                    this.search.byIncome = false
                    break

                case "byAverage":
                    this.search.byAverage  = true
                    this.search.byTotalSum = false
                    this.search.byReceiptAmount = false
                    this.search.byIncome = false
                    break

                case "byReceiptAmount":
                    this.search.byReceiptAmount = true
                    this.search.byAverage  = false
                    this.search.byTotalSum = false
                    this.search.byIncome = false
                    break

                case "byIncome":
                    this.search.byIncome = true
                    this.search.byReceiptAmount = false
                    this.search.byAverage  = false
                    this.search.byTotalSum = false
                    break
            }

            if (this.isDaily) {
                this.$store.state.saleEmployeeDaily.saleEmployeeDaily.isNeedFetch = true
                this.fetchSaleEmployeeDaily(this.search)
                    .then(() => {
                        this.saleEmployees = this.getSaleEmployeeDaily
                    })
            } else if (this.isMonthly) {
                this.$store.state.saleEmployeeMonthly.saleEmployeeMonthly.isNeedFetch = true
                this.fetchSaleEmployeeMonthly(this.search)
                    .then(() => {
                        this.saleEmployees = this.getSaleEmployeeMonthly
                    })
            } else {
                this.$store.state.saleEmployeeYearly.saleEmployeeYearly.isNeedFetch = true
                this.fetchSaleEmployeeYearly(this.search)
                    .then(() => {
                        this.saleEmployees = this.getSaleEmployeeYearly
                    })
            }
        },
        findByName() {
            if (this.isDaily) {
                this.$store.state.saleEmployeeDaily.saleEmployeeDaily.isNeedFetch = true
                this.fetchSaleEmployeeDaily(this.search)
                    .then(() => {
                        this.saleEmployees = this.getSaleEmployeeDaily
                    })
            } else if (this.isMonthly) {
                this.$store.state.saleEmployeeMonthly.saleEmployeeMonthly.isNeedFetch = true
                this.fetchSaleEmployeeMonthly(this.search)
                    .then(() => {
                        this.saleEmployees = this.getSaleEmployeeMonthly
                    })
            } else {
                this.$store.state.saleEmployeeYearly.saleEmployeeYearly.isNeedFetch = true
                this.fetchSaleEmployeeYearly(this.search)
                    .then(() => {
                        this.saleEmployees = this.getSaleEmployeeYearly
                    })
            }
        },
        getTodayDate() {
            let yearNow = new Date().getFullYear()
            let monthNow = new Date().getMonth() + 1
            let dateNow = new Date().getDate()

            return yearNow + '-' + this.addZero(monthNow) + '-' + this.addZero(dateNow)
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        },
        periodDefiner(from, to = null, isYear = false) {
            if (isYear) {
                this.period = from.toString()
                return
            }

            if (to === null) {
                this.period = this.dateFormat(from)
            } else {
                let start = this.dateFormat(from)
                let end = this.dateFormat(to)
                this.period = start + ' - ' + end
            }
        },
        async createYear() {
            let created = parseInt(this.getUserCompanyCreatedAt)

            while (created <= new Date().getFullYear()) {
                this.optionsYear.unshift({value: created, text: created})
                created++
            }

            await this.setYear()
        },
        setYear() {
            this.selectedYear = this.optionsYear[0].value
        },
        dateSwitcher() {
            this.selectedMonth = this.optionsMonth[this.currentMonth - 1].value
        },
    },
    beforeMount() {
        this.search.before = this.getTodayDate() + ' 23:59:59'
        this.search.after = this.getTodayDate() + ' 00:00:00'
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true
        this
            .fetchUser()
            .then(() => {
                this.currentMonth = new Date().getUTCMonth() + 1
                this.currentDate = this.getTodayDate()

                this.createYear()
                this.dateSwitcher()
                this.statByDays()

                this.$root.showOverlay = false
                this.$i18nHelper.flash(this.$t('statistics.info.gap'), 'info')

                this.periodDefiner(this.search.after, this.search.before)
            })
            .catch((reason) => {
                this.$root.showOverlay = false
                this.modalText = reason
                this.$bvModal.show('modal_show1')
            })
    },
}
</script>

<style scoped>

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

</style>
